import $ from 'jquery';
import PageApp from 'pageApp';
import ProsApp from '../ProsApp';
import ProsZones from '../util/ProsZones';
import LazyLoadUtil from '../util/LazyLoadUtil';

const LAZY_LOADED_ZONE = {
  [ProsZones.CAT_SPLASH_PAGE.C2FLEX_ZONE_D]: true,
  [ProsZones.BROWSE_PAGE.BROWSE_ZONE_A]: true,
  [ProsZones.SEARCH_PAGE.SEARCH_ZONE_A]: true,
};

export default class ProsController {
  constructor(configuration) {
    this.configuration = configuration;
  }

  render() {
    const prosPanelEls = $(this.configuration.selector);
    if (prosPanelEls.length > 0) {
      const {
        prosContentEnabled,
        prosCollectionsEnabled,
        prosCollectionDistProductTypeEnabled,
        lazyLoadProsPanelEnabled,
      } = PageApp.getMeta('properties');

      const that = this;
      // don't change this lambda to arrow function, as I want to use jquery $(this) inside
      prosPanelEls.each(function forEachProsEl() {
        const $this = $(this);
        const configuration = Object.assign({}, that.configuration);

        const panelOptions = ProsApp.prosPanelOptionsSetup($this, configuration, {
          prosContentEnabled, prosCollectionsEnabled, prosCollectionDistProductTypeEnabled,
        });

        const loadPanel = () => {
          PageApp.channel.trigger('pros-factory:render:zone', panelOptions);
        };

        if (lazyLoadProsPanelEnabled && LAZY_LOADED_ZONE[panelOptions.zone]) {
          new LazyLoadUtil(this).onView(loadPanel);
        } else {
          loadPanel();
        }
      });
    }
  }
}

